export const InputField = ({ label, type, id, value, onChange, placeholder, disabled }) => (
  <div className="mb-3">
    <label htmlFor={id} className="form-label fw-medium fs">
      {label}
    </label>
    <input
      type={type}
      className="form-control"
      id={id}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled} 
    />
  </div>
);
